import { UniqueCodeSchema } from "@spark/contract-book-api/schemas";
import * as z from "zod";

/**
 * @public
 */
export const CreateEmbedCodeDtoSchema = z
	.object({
		code: UniqueCodeSchema,
	})
	.meta({
		title: "CreateEmbedCodeDto",
		description: "The code from the short URL the reader was opened with.",
		examples: [{ code: "05RcS" }],
	});

export type CreateEmbedCodeDto = z.infer<typeof CreateEmbedCodeDtoSchema>;

/**
 * A temporary Readiant embed of a single document.
 *
 * @public
 */
export const EmbedCodeSchema = z
	.object({
		readiantId: z.string(),
		embedCode: z.string(),
	})
	.meta({
		title: "EmbedCode",
		description: "Readiant embed the reader iframe is pointed at.",
		examples: [
			{
				readiantId: "05RlueqwxaR5srvOyO3Q",
				embedCode: "jEJj06R1kGLgzHzs5Q7w",
			},
		],
	});

export type EmbedCode = z.infer<typeof EmbedCodeSchema>;
